export default (that) => [
  {
    field: 'seq',
    width: 60,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'defaultImageUrl',
    width: 80,
    title: that.$l('INDEX.table_label_image') || '图片',
    headerAlign: 'left',
    align: 'center',
    fixed: 'left',
    slots: { default: 'defaultImageUrl' },
  },
  {
    title: that.$l('table_label_displayName') || '产品名称',
    field: 'displayName',
    minWidth: 220,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayName' },
  },
  {
    title: that.$l('table_label_displayNo') || '产品编号',
    field: 'displayNo',
    minWidth: 200,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayNo' },
  },
  {
    title: that.$l('table_label_displayJdNo') || '京东编号',
    field: 'displayJdNo',
    minWidth: 200,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayJdNo' },
  },
  {
    title: that.$l('table_label_displayOrder') || '订单信息',
    field: 'displayOrder',
    minWidth: 260,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayOrder' },
  },
  {
    title: that.$l('table_label_purchaseQty') || '产品数',
    field: 'purchaseQty',
    minWidth: 100,
    align: 'center',
    showHeaderOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_inCtnQty') || '装箱入数',
    field: 'inCtnQty',
    minWidth: 100,
    align: 'center',
    showHeaderOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_fclCtnQty') || '箱数',
    field: 'fclCtnQty',
    minWidth: 100,
    align: 'center',
    showHeaderOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_tailInCtnQty') || '箱尾入数',
    field: 'tailInCtnQty',
    minWidth: 100,
    align: 'center',
    showHeaderOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_tailCtnQty') || '尾箱箱数',
    field: 'tailCtnQty',
    minWidth: 100,
    align: 'center',
    showHeaderOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_subCtnQty') || '总箱数',
    field: 'subCtnQty',
    minWidth: 100,
    align: 'center',
    showHeaderOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_ctnCbm') || '单箱体积',
    field: 'ctnCbm',
    minWidth: 100,
    align: 'center',
    showHeaderOverflow: true,
    formatter: ({ row }) => {
      const { ctnLength, ctnWidth, ctnHeight } = row
      const ctnCbm = that.divide(
        that.multiply(ctnLength, that.multiply(ctnWidth, ctnHeight)),
        1000000
      )
      return that.format(ctnCbm)
    },
  },
  {
    title: that.$l('table_label_subCtnCbm') || '总体积',
    field: 'subCtnCbm',
    minWidth: 100,
    align: 'center',
    showHeaderOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_ctnGrossWeight') || '单箱毛重',
    field: 'ctnGrossWeight',
    minWidth: 100,
    align: 'center',
    showHeaderOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_subCtnGrossWeight') || '总毛重(KGS)',
    field: 'subCtnGrossWeight',
    minWidth: 100,
    align: 'center',
    showHeaderOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_jdPurchasePrice') || '采购单价',
    field: 'jdPurchasePrice',
    minWidth: 100,
    align: 'center',
    showHeaderOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_purchaseAmount') || '采购金额',
    field: 'purchaseAmount',
    minWidth: 100,
    align: 'center',
    showHeaderOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_remark') || '备注',
    field: 'remark',
    minWidth: 300,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
  },
]
